import React from "react"
import { Route } from "react-router-dom"
import { RouteObject } from "."
import PrivateRoute from "./PrivateRoute"

const AppRoute: React.FC<RouteObject> = ({ isPrivate, ...routeProps }) =>
  isPrivate ? <PrivateRoute {...routeProps} /> : <Route key={routeProps.path} {...routeProps} />

export default AppRoute
